module.exports = __webpack_public_path__ + "img/logoDosp.a91c695c.jpg";